import { css } from '@emotion/react';

import generateEmotionClasses from '@core/utils/generateEmotionClasses';

export const classes = generateEmotionClasses('popoverFooter', ['root']);

const styles = css`
  box-sizing: border-box;

  .${classes.root} {
    box-sizing: inherit;
    padding: var(--popover-padding) calc(var(--popover-padding) * 2);
    border-top: 1px solid var(--cds-color-neutral-stroke-primary-weak);
    background: var(--cds-color-neutral-background-primary);
    margin-left: calc(var(--popover-padding) * -1);
    width: calc(100% + calc(var(--popover-padding) * 2));
  }
`;

export default styles;
